import React from 'react';
import ErrorMessage from '../../../ErrorMessage';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import ExternalSalesPartnerService from '../../../../Services/ExternalSalesPartnerService';

export default class ExternalSalesPartnerSelect extends React.Component {
  static defaultProps = {
    value: '',
    className: '',
    onChange: () => alert('ExternalSalesPartnerSelect Onchange'),
    fieldName: '',
    filterCleared: false,
    onlyActive: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {}

  populateListData() {
    ExternalSalesPartnerService.GetList(this.props.onlyActive)
      .then((result) => {
        let optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.forEach((user) => {
          const newValue = {
            label: `${user.name} (${user.externalSalesPartnerId})`,
            value: user.externalSalesPartnerId,
          };
          optValues.push(newValue);
        });
        this.setState({
          selectValues: optValues,
        });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('ESPS46');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
